import React from "react";
import { LoadingProvider } from "./src/context/LoadingProvider";
import { MeetingProvider } from "./src/context/MeetingProvider";
import { EmailProvider } from "./src/context/EmailProvider";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./src/theme";
import "typeface-poppins";

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <EmailProvider>
        <MeetingProvider>
          <LoadingProvider>{element}</LoadingProvider>
        </MeetingProvider>
      </EmailProvider>
    </ThemeProvider>
  );
};
